import { Link as RouterLink, useLocation } from "react-router";
import type { LinkProps } from "react-router";

export interface JntLinkProps extends LinkProps {
  preserveSearch?: boolean;
}

export default function Link({
  children,
  preserveSearch,
  to,
  ...props
}: JntLinkProps) {
  const location = useLocation();
  const proccessedTo =
    preserveSearch && typeof to === "string"
      ? { search: location.search, pathname: to }
      : to;
  return (
    <RouterLink {...props} to={proccessedTo}>
      {children}
    </RouterLink>
  );
}
